import React from "react";
import { Chart } from "react-google-charts";
import Spinner from "../../common/Spinner/Spinner";

const DeliveredResourcePieChart = ({
    data = [],
    totalResourcesDelivered = 0,
    entrepreneursCount = 0,
    isGetAllDeliveredCountLoading = false,
    isComplianceLoading = false,
    isMarketConnectLoading = false,
    isExpertConsultationLoading = false,
    isGroupKnowledgeSessionLoading = false,
    isBlrpLoading = false,
}) => {
    const isLoading =
        isGetAllDeliveredCountLoading ||
        isComplianceLoading ||
        isMarketConnectLoading ||
        isExpertConsultationLoading ||
        isGroupKnowledgeSessionLoading ||
        isBlrpLoading;

    const chartData = [["Resource", "Count"], ...(data || [])];

    return (
        <div>
            <div
                style={{
                    height: "53vh",
                    background: "#DEDEDE",
                    border: "1px lightgray solid",
                    borderRadius: "15px",
                    boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                    overflow: "hidden",
                }}
            >
                <div
                    className={`${isLoading ? "set-opacity" : ""}`}
                    style={{ height: "100%", boxSizing: "border-box" }}
                >
                    {isLoading ? <Spinner className="center" /> : null}
                    <Chart
                        width={"100%"}
                        height="100%"
                        chartType="PieChart"
                        loader={
                            <div
                                className="d-flex align-items-center justify-content-center flex-column"
                                style={{ height: "50vh" }}
                            >
                                Loading...
                            </div>
                        }
                        data={chartData}
                        options={{
                            backgroundColor: "#DEDEDE",
                            title: `${totalResourcesDelivered} resources delivered to ${entrepreneursCount ? entrepreneursCount : 0} entrepreneurs`,
                            titleTextStyle: {
                                fontSize: 10,
                                bold: true,
                                color: "#333",
                            },
                            chartArea: {
                                left: "15%",
                                width: "78%",
                                height: "50%",
                                top: 80,
                            },
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default DeliveredResourcePieChart;
